import React from 'react';
import AddIcon from '../../assets/svg/metaEdit/add_meta.svg';

const AddRowButton = ({ onClick }) => (
  <button onClick={onClick} className="meta-add">
    <img src={AddIcon} style={{ width: 20, marginRight: 10 }} alt="Add" /> Add Row
  </button>
);

export default AddRowButton;